<template>
  <div class="preview-viewer preview-yiqixie-viewer">
    <iframe v-if="link" :src="link" id="yiqixie_frame" name="yiqixie_frame"></iframe>
  </div>
</template>
<script>
import { GET_YQX_URL } from '@/config/api'
import ajax from '@/utils/ajax'

export default {
  name: 'YqxViewer',
  props: {
    item: Object,
    scenario: String
  },
  data () {
    return {
      timeStamp: +new Date(),
      link: ''
    }
  },
  mounted () {
    this.getYqxUrl()
  },
  methods: {
    getYqxUrl () {
      let url = `${GET_YQX_URL}?file_id=${this.item.id}`
      if (this.scenario) {
        url += `&scenario=${this.scenario}`
      }
      ajax({
        url
      }).then(res => {
        if (res && res.success) {
          this.link = res.access_url
        }
      })
    }
  }
}
</script>
<style lang="postcss">
  .preview-yiqixie-viewer {
    & iframe {
      flex: 1 1 auto;
      width: 100%;
      height: 100%;
      border: 0
    }
  }
</style>
